import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  CompanyList,
  RoleList,
  SubScriptionList,
} from "./Components/DummyData";

const authReducer = (
  state = {
    isLoggedIn: -1,
    isAuthenticated: -1,
  },
  action
) => {
  switch (action.type) {
    case "AUTH_LOAD_SUCCESS":
      return {
        ...state,
        isAuthenticated: action?.payload?.isAuthenticated,
        isLoggedIn: true,
        user: action?.payload?.result,
      };
    case "AUTH_LOAD_FAILURE":
      return {
        ...state,
        isLoggedIn: false,
        isAuthenticated: false,
      };
    case "LOGIN_SUCCESS":
      return {
        ...state,
        isLoggedIn: true,
        isAuthenticated: true,
        user: action?.payload,
      };

    case "AUTH_LOGOUT_SUCCESS":
      return {
        ...state,
        isAuthenticated: false,
        isLoggedIn: false,
        user: undefined,
      };
    case "AUTH_FORGOTPASS_MAIL_SUCCESS":
    case "AUTH_FORGOTPASS_SUCCESS":
      return { ...state, error: undefined };
    case "AUTH_USER_CREATE_SUCCESS":
      return { ...state };
    case "GET_PROFILE":
      return {
        ...state,
        user: action.payload,
      };
    default:
      return state;
  }
};

const errorReducer = (
  state = { authError: undefined, carError: undefined },
  action
) => {
  switch (action.type) {
    case "SET_ERROR":
      const temp = {};
      const { payload } = action;

      if (payload.status && payload.status.length) {
        payload.status &&
          payload?.status.forEach((ele) => {
            if (ele.param === "_error") {
              ele.nestedErrors?.forEach((ele1) => {
                const key = ele1.param.split(".").pop();
                temp[key] = ele1.msg;
              });
            } else if (ele.param?.includes("updates.")) {
              const key = ele.param.split(".").slice(1).join(".");
              temp[key] = ele.msg;
            } else {
              temp[ele.path] = ele.msg;
            }
          });
      }

      return { ...state, [`${payload.scope}Error`]: temp };

    default:
      return state;
  }
};

const loadingReducer = (state = { authLoading: false }, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return Object.assign({}, state, {
        [`${action.payload.scope}Loading`]: action.payload.status,
      });
    default:
      return state;
  }
};

const msgReducer = (
  state = { success: undefined, error: undefined },
  action
) => {
  switch (action.type) {
    case "SET_TOAST":
      return Object.assign({}, state, {
        [`${action.payload.scope}`]:
          action.payload.status || "Something went wrong!",
      });
    case "CLEAR_TOAST":
      return { ...state, error: undefined, success: undefined };
    default:
      return state;
  }
};

// Plan
const managePlanReducer = (
  state = {
    managePlanList: undefined,
    subscriptionFeature: undefined,
  },
  action
) => {
  switch (action.type) {
    case "GET_MANAGE_PLAN":
      return {
        ...state,
        managePlanList: action.payload,
      };
    case "GET_SUBSCRIPTION_FEATURE":
      return {
        ...state,
        subscriptionFeature: action.payload,
      };
    default:
      return state;
  }
};

const faqReducer = (
  state = {
    faqList: undefined,
  },
  action
) => {
  switch (action.type) {
    case "GET_FAQS_LIST":
      return {
        ...state,
        faqList: action.payload,
      };
    default:
      return state;
  }
};

const planReducer = (
  state = {
    currentPlan: undefined,
    planHistory: undefined,
    planHistoryInfo: undefined,
    paymentMethod: undefined,
  },
  action
) => {
  switch (action.type) {
    case "GET_CURRENT_PLAN":
      return {
        ...state,
        currentPlan: action.payload,
      };
    case "GET_TRANSACTION_HISTORY":
      return {
        ...state,
        planHistory: action.payload,
      };
    case "GET_TRANSACTION_INFO_HISTORY":
      return {
        ...state,
        planHistoryInfo: action.payload,
      };
    case "GET_PAYMENT_METHOD":
      return {
        ...state,
        paymentMethod: action.payload,
      };
    case "CLEAR_PLAN_REDUCER":
      return {
        ...state,
        currentPlan: undefined,
        planHistory: undefined,
        paymentMethod: undefined,
      };
    default:
      return state;
  }
};

const BetaReducer = (
  state = {
    content: undefined,
    teamMember: undefined,
  },
  action
) => {
  switch (action.type) {
    case "GET_BETA_PROGRAM_CONTENT":
      return {
        ...state,
        content: action.payload,
      };
    case "GET_ORGANIZATION_MEMBER":
      return {
        ...state,
        teamMember: action.payload,
      };
    case "CLEAR_BETA":
      return {
        ...state,
        content: undefined,
        teamMember: undefined,
      };
    default:
      return state;
  }
};

const d = `d-flex`;
const da = `${d} align-items-center`;
const dab = `${da} justify-content-between`;
const tableCard = `card card-shadow rounded-4 border-0 overflow-hidden`;
const tableCardBody = `card-body p-0 shadow-sm`;
const tableClass = `antTable mt-1 antTableCommandDesk`;
const classReducer = (
  state = {
    d: d,
    da: da,
    dab: dab,
    tCard: tableCard,
    tCardBody: tableCardBody,
    tClass: tableClass,
  },
  action
) => {
  switch (action.type) {
    case "CLASS":
      return {
        ...state,
      };
    default:
      return state;
  }
};

const store = configureStore({
  reducer: combineReducers({
    auth: authReducer,
    error: errorReducer,
    loading: loadingReducer,
    msg: msgReducer,
    managePlan: managePlanReducer,
    class: classReducer,
    faq: faqReducer,
    plan: planReducer,
    beta: BetaReducer,
  }),
});

export default store;
